import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class InternationalPaymentService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  interntionalPaymentsData: any;

  private interntionalPaymentsHeroSubject$ = new BehaviorSubject<any>(null);
  public interntionalPaymentsHero$ =
    this.interntionalPaymentsHeroSubject$.asObservable();
  private interntionalPaymentsCustomerStatsSubject$ = new BehaviorSubject<any>(
    null
  );
  public interntionalPaymentsCustomerStats$ =
    this.interntionalPaymentsCustomerStatsSubject$.asObservable();
  private interntionalPaymentsFeaturePanel1Subject$ = new BehaviorSubject<any>(
    null
  );
  public interntionalPaymentsFeaturePanel1$ =
    this.interntionalPaymentsFeaturePanel1Subject$.asObservable();
  private interntionalPaymentsFeaturePanel2Subject$ = new BehaviorSubject<any>(
    null
  );
  public interntionalPaymentsFeaturePanel2$ =
    this.interntionalPaymentsFeaturePanel2Subject$.asObservable();
  private interntionalPaymentsVideoPanelSubject$ = new BehaviorSubject<any>(
    null
  );
  public interntionalPaymentsVideoPanel$ =
    this.interntionalPaymentsVideoPanelSubject$.asObservable();
  private interntionalPaymentsCustomerStoryPanelSubject$ =
    new BehaviorSubject<any>(null);
  public interntionalPaymentsCustomerStoryPanel$ =
    this.interntionalPaymentsCustomerStoryPanelSubject$.asObservable();
  private interntionalPaymentsDiscoverDifferencePanelSubject$ =
    new BehaviorSubject<any>(null);
  public interntionalPaymentsDiscoverDifferencePanel$ =
    this.interntionalPaymentsDiscoverDifferencePanelSubject$.asObservable();
  private interntionalPaymentsPricingPanelSubject$ = new BehaviorSubject<any>(
    null
  );
  public interntionalPaymentsPricingPanel$ =
    this.interntionalPaymentsPricingPanelSubject$.asObservable();
  private interntionalPaymentsWhitePaperPanelSubject$ =
    new BehaviorSubject<any>(null);
  public interntionalPaymentsWhitePaperPanel$ =
    this.interntionalPaymentsWhitePaperPanelSubject$.asObservable();
  private getStartedSubject$ = new BehaviorSubject<any>(null);
  public getStarted$ = this.getStartedSubject$.asObservable();

  // private interntionalPaymentsHeroSubject$ = new BehaviorSubject<any>(null);
  // public interntionalPaymentsHero$ = this.interntionalPaymentsHeroSubject$.asObservable();
  // private interntionalPaymentsCustomerStatsSubject$ = new BehaviorSubject<any>(null);
  // public interntionalPaymentsCustomerStats$ = this.interntionalPaymentsCustomerStatsSubject$.asObservable();
  // private interntionalPaymentsCoverageSubject$ = new BehaviorSubject<any>(null);
  // public interntionalPaymentsCoverage$ = this.interntionalPaymentsCoverageSubject$.asObservable();
  // private interntionalPaymentsFeatureSubject$ = new BehaviorSubject<any>(null);
  // public interntionalPaymentsFeatures$ = this.interntionalPaymentsFeatureSubject$.asObservable();
  // private interntionalPaymentsValuesSubject$ = new BehaviorSubject<any>(null);
  // public interntionalPaymentsValues$ = this.interntionalPaymentsValuesSubject$.asObservable();
  // private getStartedSubject$ = new BehaviorSubject<any>(null);
  // public getStarted$ = this.getStartedSubject$.asObservable();

  getinterntionalPaymentsPageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.interntionalPaymentsData = mod.filter(
          x => x?.fields['id'] == PageId.internationalPaymentsPage
        );

        const heroData =
          this.interntionalPaymentsData[0].fields.psHeroPanel.fields;
        if (heroData) {
          this.interntionalPaymentsHeroSubject$.next(heroData);
        }
        const featurePanel1 =
          this.interntionalPaymentsData[0]?.fields?.psFeatures[0]?.fields;
        if (featurePanel1) {
          this.interntionalPaymentsFeaturePanel1Subject$.next(featurePanel1);
        }
        const featurePanel2 =
          this.interntionalPaymentsData[0]?.fields?.psOtherProductsPanel
            ?.fields;
        if (featurePanel2) {
          this.interntionalPaymentsFeaturePanel2Subject$.next(featurePanel2);
        }
        const videoPanel =
          this.interntionalPaymentsData[0]?.fields?.psProductVideo?.fields;
        if (videoPanel) {
          this.interntionalPaymentsVideoPanelSubject$.next(videoPanel);
        }
        const customerStoryPanel =
          this.interntionalPaymentsData[0]?.fields?.psCustomerStories?.fields;
        if (customerStoryPanel) {
          this.interntionalPaymentsCustomerStoryPanelSubject$.next(
            customerStoryPanel
          );
        }
        const discoverDifferencePanel =
          this.interntionalPaymentsData[0]?.fields?.psTableFeaturesComparison
            ?.fields;
        if (discoverDifferencePanel) {
          this.interntionalPaymentsDiscoverDifferencePanelSubject$.next(
            discoverDifferencePanel
          );
        }
        const pricingPanel =
          this.interntionalPaymentsData[0]?.fields?.psPricingPanel?.fields;
        if (pricingPanel) {
          this.interntionalPaymentsPricingPanelSubject$.next(pricingPanel);
        }
        const whitePaperPanel =
          this.interntionalPaymentsData[0]?.fields?.psWhitepaperForm?.fields;
        if (whitePaperPanel) {
          this.interntionalPaymentsWhitePaperPanelSubject$.next(
            whitePaperPanel
          );
        }
        const getStarted =
          this.interntionalPaymentsData[0].fields.psGetStartedPanel.fields;
        if (getStarted) {
          this.getStartedSubject$.next(getStarted);
        }
      });
  }
}
